import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import api from '../lib/api';
import { LessonCard } from '../components/LessonCard';
import { Spinner } from '../components/ui/Spinner';

export default function TopicLessons() {
  const { topic } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    api
      .get(`/topic/${encodeURIComponent(topic)}/lessons`)
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, [topic]);

  if (loading)
    return (
      <div className="grid h-[60vh] place-items-center">
        <Spinner className="h-8 w-8" />
      </div>
    );

  const lessons = data?.lessons || [];
  const color = data?.color || '#10B981';

  return (
    <div className="space-y-8">
      <button onClick={() => navigate('/app/courses')} className="flex items-center gap-2 text-sm text-zinc-500 hover:text-white" data-testid="topic-back">
        <ChevronLeft size={16} /> All courses
      </button>

      <div className="overflow-hidden rounded-3xl border p-8 lg:p-10" style={{ borderColor: `${color}33`, background: `${color}10` }}>
        <h1 className="font-heading text-4xl font-extrabold tracking-tighter text-white">{topic}</h1>
        {data?.description && <p className="mt-2 max-w-2xl text-zinc-400">{data.description}</p>}
        <div className="mt-3 tnum text-sm" style={{ color }}>
          {lessons.length} lessons
        </div>
      </div>

      {lessons.length ? (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {lessons.map((l, i) => (
            <LessonCard key={l.lesson_id} lesson={l} index={i} />
          ))}
        </div>
      ) : (
        <div className="rounded-3xl border border-white/5 bg-ink-card p-16 text-center text-zinc-500">
          No lessons in this topic yet.
        </div>
      )}
    </div>
  );
}
